import { parseMacroAndSendToChat } from '../Util/MacroParser';

const parseOptions = (options) => {
    if (!options) {
        return [];
    }

    const lines = options.split('\n');
    const RegExValue = /^(.*?)(?:\s(.*))?$/i;
    const result = [];

    for(let line of lines) {
        let parts = RegExValue.exec(line);
        if (parts) {
            result.push({value: parts[1], label: parts[2] || parts[1]});
        }
    }

    return result;
}

export default class Field {

    constructor() {
        this.manager = null;
        this.id = (new Date()).getTime();
        this.type = '';
        this.name = '';
        this.nameId = '';
        this.options = '';
        this.optionsParsed = [];
        this.startPoint = [0,0];
        this.endPoint = [0,0];
        this.elements = {};
        this.maxSize = [36, 52];
        this.minSize = [1,1];
        this.props = {
            label: '',
            name: '',
            nameId: '',
            defaultValue: '',
            options: '',
            optionsParsed: [],
            auto: false,
            expression: '',
            macro: '',
            macroCtrl: '',
            resourceId: '',
            resourceName: '',
            textAlign: '',
            textSize: '',
            hasDetails: false,
        }

        this.runMacroCallback = () => {};

        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
    }

    export() {
        return {
            id: this.id,
            type: this.type,
            name: this.name,
            nameId: this.nameId,
            defaultValue: this.defaultValue,
            options: this.options,
            startPoint: this.startPoint,
            endPoint: this.endPoint,
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height,
            props: {
                label: this.props.label,
                name: this.props.name,
                nameId: this.props.nameId,
                defaultValue: this.props.defaultValue,
                options: this.props.options,
                optionsParsed: this.props.optionsParsed,
                auto: this.props.auto,
                expression: this.props.expression,
                macro: this.props.macro,
                macroCtrl: this.props.macroCtrl,
                resourceId: this.props.resourceId,
                resourceName: this.props.resourceName,
                textAlign: this.props.textAlign,
                textSize: this.props.textSize,
                hasDetails: this.props.hasDetails,
                type: this.type,
                x: this.x,
                y: this.y,
                width: this.width,
                height: this.height,
            }
        }
    }

    setManager(manager) {
        this.manager = manager;
    }

    setId(id) {
        this.id = id;
    }

    setName(name) {
        this.name = name;
    }

    setNameId(nameId) {
        this.nameId = nameId;
    }

    setDefaultValue(defaultValue) {
        this.defaultValue = defaultValue;
    }

    setOptions(options) {
        this.options = options;
        this.optionsParsed = parseOptions(options);
    }

    setStartPoint(startPoint) {
        this.startPoint = startPoint;
        this.normalize();
    }

    setX(x) {
        this.x = x;
    }

    setY(y) {
        this.y = y;
    }

    setEndPoint(endPoint) {
        this.endPoint = endPoint;
        this.normalize();
    }

    setRunMacroCallback(fn) {
        this.runMacroCallback = fn;
    }

    setProps(props) {
        let keys = Object.keys(props);
        for(let k of keys) {
            if (this.props.hasOwnProperty(k)) {
                this.props[k] = props[k]
            }

            if (['x', 'y', 'width', 'height'].indexOf(k) >= 0) {
                this[k] = parseInt(props[k]);
            }

            if (['name', 'nameId', 'defaultValue'].indexOf(k) >= 0) {
                this[k] = String(props[k]);
            }

            if ('options' === k) {
                this['options'] = String(props['options']);
                this['optionsParsed'] = parseOptions(props['options']);
            }
        }

        this.validateProps();
        this.calculatePoints();
    }
    

    getProps() {
        return {
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height,
            name: this.name,
            nameId: this.nameId,
            defaultValue: this.defaultValue,
            type: this.type,
            ...this.props
        }
    }

    validateProps() {
        this.width = Math.min(Math.max(this.width, this.minSize[0]), this.maxSize[0]);
        this.height = Math.min(Math.max(this.height, this.minSize[1]), this.maxSize[1]);
    }

    remove() {
        for(let element of Object.values(this.elements)) {
            if (element && element.parentNode) {
                element.parentNode.removeChild(element);
            }
        }
    }

    normalize() {
        this.x = Math.min(this.startPoint[0], this.endPoint[0]);
        this.y = Math.min(this.startPoint[1], this.endPoint[1]);

        let hdistance = this.endPoint[0] - this.startPoint[0];
        let vdistance = this.endPoint[1] - this.startPoint[1];

        let width = Math.abs(hdistance);
        let height = Math.abs(vdistance);

        if (hdistance < 0) {
            width = width + 1;
        }
        
        this.width = Math.min(Math.max(width, this.minSize[0]), this.maxSize[0]);
        this.height = Math.min(Math.max(height, this.minSize[1]), this.maxSize[1]);

    }

    calculatePoints() {
        this.startPoint = [this.x, this.y];
        this.endPoint = [this.x + this.width, this.y + this.height];
    }

    runMacro(mod='') {
        let sheet = this.manager.getValues();
        let macroToRun = this.props.macro;

        if (mod === 'ctrl' && this.props.macroCtrl) {
            macroToRun = this.props.macroCtrl
        }

        parseMacroAndSendToChat(macroToRun, sheet, () => {
            this.runMacroCallback();
        });
    }

}